import PopEdit from './components/PopEdit';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'popEdit',
  pluginComponent: PopEdit,
});
